import React from 'react';
import ContactSection from './ContactSection';

const ContactPage = ({ title, subTitle, backgroundImage, highlightWord }) => {
  return (
    <ContactSection
      title={title}
      subTitle={subTitle}
      backgroundImage={backgroundImage}
      highlightWord={highlightWord}
    />
  );
};

export default ContactPage;
